
import { defineComponent } from "@vue/runtime-core";
import Ripple from "primevue/ripple";
import store from "../store/index";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import { useRouter, useRoute } from "vue-router";
import router from "../router";

const axioCred = axios.create({
  withCredentials: true,
});

export default defineComponent({
  name: "HeaderItem",
  setup() {
    const router = useRouter();
    const route = useRoute();
    return {
      router,
      route,
    };
  },
  data() {
    return {
      isOpened: false,
    };
  },
  methods: {
    ...mapActions("auth", {
      actionLogout: "logout",
    }),
    // logout() {
    //   this.actionLogout();
    //   this.$router.push("/login");
    //   this.isOpened = !this.isOpened;
    // },
    logout() {
      axioCred.post(`https://www.biletdv.ru/customer/IBEServices/Logout`).then((res) => {
        if (res.status == 200) {
          this.isOpened = !this.isOpened;
          this.actionLogout();
          router.push("/login");
        }
      });
    },
    menuHandler() {
      this.isOpened = true;
    },
    onClickAway() {
      this.isOpened = false;
    },
    // authState() {
    //   if (store.module.auth.loginStatus == )
    // }
  },
  directives: {
    ripple: Ripple,
  },
});
